(function () {
  'use strict';

  var COMPARE_KEY = 'tcb_compare_list';
  var MAX_COMPARE = 4;

  function getList() {
    try {
      var raw = localStorage.getItem(COMPARE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setList(list) {
    localStorage.setItem(COMPARE_KEY, JSON.stringify(list.slice(0, MAX_COMPARE)));
    document.dispatchEvent(new CustomEvent('tcb:compare-updated', { detail: { handles: getList() } }));
  }

  function compareUrl(handles) {
    var url = '/pages/equipment-comparison';
    if (handles && handles.length >= 2) {
      url += '?custom=' + handles.join(',');
    }
    return url;
  }

  window.tcbAddToCompare = function (handle) {
    if (!handle) return false;
    var list = getList();
    if (list.indexOf(handle) !== -1) return true;
    if (list.length >= MAX_COMPARE) {
      list.shift();
    }
    list.push(handle);
    setList(list);
    return true;
  };

  window.tcbRemoveFromCompare = function (handle) {
    if (!handle) return false;
    var list = getList().filter(function (item) {
      return item !== handle;
    });
    setList(list);
    return true;
  };

  function syncControl(control) {
    var handle = control.getAttribute('data-product-handle');
    if (!handle) return;
    var inList = getList().indexOf(handle) !== -1;

    if (control.type === 'checkbox') {
      control.checked = inList;
      return;
    }

    if (control.tagName === 'BUTTON') {
      var label = control.getAttribute('data-label-added') || 'Added ✓';
      control.textContent = inList ? label : (control.getAttribute('data-label-default') || 'Add to Compare');
      control.setAttribute('aria-pressed', inList ? 'true' : 'false');
    }
  }

  function syncCompareControls() {
    var list = getList();
    document.querySelectorAll('[data-tcb-add-compare]').forEach(syncControl);
    document.querySelectorAll('[data-tcb-compare-link]').forEach(function (link) {
      link.setAttribute('href', compareUrl(list));
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-tcb-add-compare]');
    if (!input || input.type !== 'checkbox') return;

    var handle = input.getAttribute('data-product-handle');
    if (!handle) return;

    if (input.checked) {
      window.tcbAddToCompare(handle);
    } else {
      window.tcbRemoveFromCompare(handle);
    }
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-tcb-add-compare]');
    if (!btn || btn.type === 'checkbox') return;
    event.preventDefault();

    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    var added = window.tcbAddToCompare(handle);
    var label = btn.getAttribute('data-label-added') || 'Added to compare';
    if (added) {
      btn.textContent = label;
      btn.setAttribute('aria-pressed', 'true');
    }
    btn.setAttribute('title', 'View compare list at ' + compareUrl(getList()));
  });

  document.addEventListener('DOMContentLoaded', syncCompareControls);
  document.addEventListener('tcb:compare-updated', syncCompareControls);
})();
